var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Select',{attrs:{"name":_vm.name,"options":_vm.types,"multiple":_vm.multiple,"searchable":true,"rules":_vm.rules,"reduce":item => item.value,"placeholder":_vm.placeholder,"appendToBody":_vm.appendToBody},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }